import { CommonModule } from '@angular/common';
import { Component, DestroyRef, Inject, OnInit, inject } from '@angular/core';
import { WidgetModalType } from 'app/shared/models/widget-modal-type';
import { APP_STORAGE } from 'app/shared/constants/app.constant';
import { IRxStorage } from '@rxjs-storage/core/dist/types/internal/interfaces';
import { AuthService } from 'app/shared/services/auth.service';
import { AppConfigService } from 'app/shared/services/app-config.service';
import { ScreenService } from 'app/shared/services/screen.service';
import { ModalModule } from '@components/modal/modal.module';
import { ButtonModule } from '@components/button/button.module';
import { MainMapService } from '@components/main-map/main-map.service';
import { TranslationService } from 'app/shared/services/translation.service';
import { availableLanguages } from 'translations';

const splashClosedKey = 'SPLASH:CLOSED';

@Component({
  selector: 'app-splash-modal',
  templateUrl: 'splash-modal.component.html',
  styleUrls: ['splash-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, ModalModule, ButtonModule],
})
export class SplashModalComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  visible: boolean;
  logoSrc: string = 'assets/geoanacom.png';

  private storageClosedKey: string;

  get isMobileMode() {
    return this.screenService.isMobileScreen();
  }

  get isHandsetLandscapeMode() {
    return this.screenService.isHandsetLandscape();
  }

  constructor(
    private appConfig: AppConfigService,
    private authService: AuthService,
    private mainMapService: MainMapService,
    private screenService: ScreenService,
    @Inject(APP_STORAGE) private storage: IRxStorage,
    public ts: TranslationService
  ) {}

  ngOnInit(): void {
    this.visible = true;

    if (this.ts.getCurrentLanguageCode() === availableLanguages.en) {
      this.logoSrc = 'assets/geoanacom_logo_en.png';
    }

    // let observable: Observable<string>;
    // if (this.appConfig.externalMode) {
    //   observable = of('');
    // } else {
    //   observable = this.authService.getUserId();
    // }

    // observable
    //   .pipe(
    //     map((userName) => {
    //       return `${userName ?? ''}-${splashClosedKey}`;
    //     }),
    //     takeUntilDestroyed(this.destroyRef)
    //   )
    //   .subscribe((key) => {
    //     this.storageClosedKey = key;

    //     this.visible = !this.storage.getItem<boolean>(this.storageClosedKey);
    //   });
  }

  onHidden() {
    // this.storage.setItem(this.storageClosedKey, true);
  }

  onHelpClick() {
    this.mainMapService.openWidgetModal(WidgetModalType.Help);
    this.visible = false;
  }
}
